module.exports = __webpack_public_path__ + "img/minus_btn.7933e909.png";